import { RecordType } from '../types/api';
/**
 * Which types the form-config settings screen can edit. Must stay a subset of
 * the backend's `ModuleSettingDefaultsLoader.FORM_CONFIG_TYPES` — a type listed
 * here but not allowlisted there has no seeded row, so the editor opens on a 404.
 *
 * <p>Lives in its own module (CZNA-502) so `recordTypeLabels.test.ts` can assert
 * a `settings.forms.recordType.*` translation exists for every entry without
 * importing the whole settings screen. The list IS the contract: adding a type
 * here and forgetting its label turns that test red.
 */
var FORM_CONFIG_RECORD_TYPES = [
    RecordType.PERSONAL,
    RecordType.CORPORATE,
    RecordType.MEETING,
    RecordType.UNIFORM_TITLE,
    // CZNA-490: author–title authority (1XX with $t, author-work.json). CZNA-458 left
    // it out with the reasoning "no cataloguer can reach it, so there is no form worth
    // editing" — CZNA-492 then added it to `AuthorityTypeDialog.TYPE_ORDER`, which
    // retires that reasoning: the type can now be created, so its form must be tunable
    // like every other creatable type's.
    RecordType.AUTHOR_WORK,
    RecordType.SUBJECT,
    RecordType.GEOGRAPHIC,
    // CZNA-181: old-print city (Aleph prefix pv, MARC 195). Its packaged default
    // (old-print-city.json) is seeded by the backend loader, so it is editable here.
    RecordType.OLD_PRINT_CITY,
    // CZNA-458: UNIFORM_TITLE above was listed here before its uniform-title.json
    // existed — the screen offered a type whose editor could only 404. That file now
    // ships, together with these two; all three are offered by AuthorityTypeDialog.
    RecordType.CHRONOLOGICAL,
    RecordType.GENRE_FORM,
    // CZNA-491: conspect group (Aleph prefix sk, MARC 190). Listed here because the 624
    // existing conspect records DO open this form — `RecordEdit` passes `record.type`
    // straight into `useFormConfig` — so an admin has a real reason to tune it.
    // CZNA-1087: the type is no longer held out of `AuthorityTypeDialog.TYPE_ORDER`
    // either (creation is now gated by role × type in the backend), and it is the first
    // type to ship TWO packaged templates — the skupina default and `kategorie`. This
    // screen edits whichever template it is pointed at; the shape predicate that decides
    // which one a RECORD opens in lives in the template itself (`appliesWhen`).
    RecordType.CONSPECT_GROUP,
];
export default FORM_CONFIG_RECORD_TYPES;
